// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-section-delete{
  padding: 48px 3px 56px 3px;
  text-align: center;
}
.modal-section-delete-text{ 
  color: var(--black, #000);
display: flex;
flex-direction: column;
align-items: center;
font-feature-settings: 'liga' off, 'clig' off;
font-family: "Henkel GT Flexa";
font-size: 24px;
font-style: normal;
font-weight: 500;
line-height: normal;
display: flex;
}
.modal-section-delete-sub-text{
  color: var(--black, #000);
  text-align: center;
  font-family: "Segoe UI";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
  margin-top: 8px;
}

.modal-section-delete-sub-text > div {
  margin-bottom: 4px;
}

.modal-section-delete-sub-text > div:last-child {
  margin-bottom: 0;
}
.modal-section-delete button{
  width: 96px;
height: 36px;
flex-shrink: 0;
border-radius: 18px;
}
.modal-section-delete button:first-child{
  margin-right:20px;
}
.modal-section-delete button:last-child{
  margin-left:20px;
}`, "",{"version":3,"sources":["webpack://./src/components/confirm-modal/index.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B,aAAa;AACb,sBAAsB;AACtB,mBAAmB;AACnB,6CAA6C;AAC7C,8BAA8B;AAC9B,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB,aAAa;AACb;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb,YAAY;AACZ,cAAc;AACd,mBAAmB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".modal-section-delete{\n  padding: 48px 3px 56px 3px;\n  text-align: center;\n}\n.modal-section-delete-text{ \n  color: var(--black, #000);\ndisplay: flex;\nflex-direction: column;\nalign-items: center;\nfont-feature-settings: 'liga' off, 'clig' off;\nfont-family: \"Henkel GT Flexa\";\nfont-size: 24px;\nfont-style: normal;\nfont-weight: 500;\nline-height: normal;\ndisplay: flex;\n}\n.modal-section-delete-sub-text{\n  color: var(--black, #000);\n  text-align: center;\n  font-family: \"Segoe UI\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%; /* 24px */\n  margin-top: 8px;\n}\n\n.modal-section-delete-sub-text > div {\n  margin-bottom: 4px;\n}\n\n.modal-section-delete-sub-text > div:last-child {\n  margin-bottom: 0;\n}\n.modal-section-delete button{\n  width: 96px;\nheight: 36px;\nflex-shrink: 0;\nborder-radius: 18px;\n}\n.modal-section-delete button:first-child{\n  margin-right:20px;\n}\n.modal-section-delete button:last-child{\n  margin-left:20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
